import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Progress } from 'antd';
import { Offline } from 'react-detect-offline';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useI18n } from '@newtontechnologies/applib-frontend';
import { useUploadStatus } from '../../../../upload-context';
import './style.less';
const TaskProgress = ({ splitFiles, task, }) => {
    const { intl } = useI18n();
    const uploadStatus = useUploadStatus();
    const { uploadFinished, uploadProgress } = uploadStatus;
    const uploading = splitFiles.length === 0 && !uploadFinished;
    const creatingSplits = splitFiles.length === 0 && uploadFinished;
    if (uploading) {
        return (_jsxs(_Fragment, { children: [_jsx(Offline, { children: _jsxs("div", { className: "task-status__offline-warning", children: [_jsx(InfoCircleOutlined, {}), _jsx("p", { children: intl.formatMessage({ id: 'offlineWarning' }) })] }) }), _jsxs("div", { className: "task-status", children: [_jsx("p", { className: "task-status__message", children: intl.formatMessage({ id: 'uploading' }) }), uploadProgress > 0 ? (_jsx(Progress, { percent: uploadProgress, status: "active" })) : null] })] }));
    }
    if (creatingSplits) {
        return (_jsx("p", { children: intl.formatMessage({ id: 'splittingFiles' }) }));
    }
    const count = splitFiles.reduce((acc, item) => (item.fileTranscribed ? acc + 1 : acc), 0);
    const percent = (count / splitFiles.length) * 100;
    const progressStatus = () => {
        if (splitFiles.every((file) => file.fileTranscribed)) {
            return 'success';
        }
        return 'normal';
    };
    return (_jsxs("div", { className: "task-status", children: [_jsx("span", { className: "task-status__message", children: intl.formatMessage({ id: 'transcribedFiles' }) }), splitFiles.length > 20 ? (_jsx(Progress, { percent: percent, status: task.haveSplitErrors ? 'exception' : 'active' })) : (_jsx(Progress, { percent: percent, steps: splitFiles.length, format: () => `(${count}/${splitFiles.length})`, status: progressStatus(), strokeColor: task.haveSplitErrors ? '#FF4D4F' : '#1890FF' }))] }));
};
export default TaskProgress;
